/* eslint-disable @typescript-eslint/naming-convention */
const translations = {
  community_chat_accepted: "{displayName} accepted this chat",
  community_chat_closed: "{displayName} left this chat",
  community_chat_declined: "{displayName} declined this chat",
  community_chat_reopened: "{displayName} rejoined this chat"
};

export default translations;
